import { ref, reactive } from 'vue'
import { ElMessage } from 'element-plus'

/**
 * 全局登录态（单一数据源）
 *
 * 背景：云端 Token 已升级为签名 Token（v1.<payload>.<hmac>），旧 Token 一律被拒（HTTP 401）。
 * 之前 token 只放在 AdminView 组件内的普通 ref 中、且仅在 onMounted 用 localStorage 播种一次；
 * 401 清掉 localStorage 后组件状态不变，用户必须手动刷新浏览器才能重新看到登录框。
 * 现在 token 由本模块统一持有（ref 与 localStorage 同步），任何一处 401 都会清空它，
 * 界面随 `auth.token` 立即切回登录页，无需刷新。
 */

const TOKEN_KEY = 'admin_token'
const USER_KEY = 'admin_user'

// 统一文案：401 时既作提示，也作抛给调用方的错误信息，避免各处重复弹窗
export const AUTH_EXPIRED_MESSAGE = '登录已过期，请重新登录'

// 首次加载时 localStorage 可能没有值，此时为空字符串（即未登录）
export const token = ref(localStorage.getItem(TOKEN_KEY) || '')
export const user = ref(localStorage.getItem(USER_KEY) || '')

// 供模板使用：reactive 会自动解包 ref，模板里直接写 auth.token / auth.user
export const store = reactive({ token, user })

/* ---------- 内部：同步 localStorage ---------- */
function persistToken(value) {
  if (value) localStorage.setItem(TOKEN_KEY, value)
  else localStorage.removeItem(TOKEN_KEY)
}

function persistUser(value) {
  if (value) localStorage.setItem(USER_KEY, value)
  else localStorage.removeItem(USER_KEY)
}

/* ---------- 登录 / 退出 ---------- */
export function login(newToken, username) {
  store.token = newToken || ''
  store.user = username || ''
  persistToken(store.token)
  persistUser(store.user)
}

export function logout() {
  store.token = ''
  store.user = ''
  persistToken('')
  persistUser('')
}

/* ---------- 401 统一处理：清 Token + 提示重新登录 ---------- */
// 多个请求同时 401 时只提示一次，避免刷屏
let expiredTipAt = 0

export function handleAuthExpired() {
  const now = Date.now()
  if (now - expiredTipAt > 3000) {
    expiredTipAt = now
    ElMessage.error(AUTH_EXPIRED_MESSAGE)
  }
  logout()
}
